<script>
import UserDetailContactTile from '@/components/user/tiles/UserDetailContactTile.vue';
import FormBlock from '@/components/FormBlock.vue';
import BaseTabs2 from '@/components/BaseTabs2.vue';
// import CarouselArrows from '@/components/ui/CarouselArrows.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';

export default {
  name: 'UserDetailContactsTile2',
  components: {
    FormBlock,
    BaseTabs2,
    // CarouselArrows,
    AvatarEditable,
    UserDetailContactTile,
  },
  props: {
    contacts: Object,
  },
  data() {
    return {
      tab: 'accepted',
    };
  },
  computed: {
    tabs() {
      return [
        { name: 'accepted',     label: 'Мои контакты' }, // eslint-disable-line
        { name: 'incoming',     label: 'Входящие заявки' }, // eslint-disable-line
        { name: 'outComing',    label: 'Исходящие заявки' }, // eslint-disable-line
      ];
    },

    selectedContacts() {
      return this.contacts[this.tab];
    },
  },
};
</script>

<template lang="pug">
FormBlock(mobile)
  .b-user-detail-contacts-tile2
    ._header
      ._label Контакты
    ._tabs
      BaseTabs2._tile-tabs(:items="tabs" :value="tab" @input="tab = $event")
      //CarouselArrows._tile-arrows
    ._contacts
      UserDetailContactTile(v-for="contact in selectedContacts" :key="contact['@id']" :contact="contact" grey)
</template>

<style scoped lang="scss">
.user-detail-contacts-tile2 {
  &__contacts-tile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 6px;
    border-bottom: 1px solid rgb(235, 239, 242);
  }

  &__label {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
  }

  &__tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 0 30px 0;
  }

  &__contacts {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }
}
</style>
